import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../uicomponent';

import { LoaderCSSStyleImpl } from './loadercss';

import { BaseContext } from '../../../utils/basecontext';

import { UIComponentView } from '../uicomponentview';

import { LoaderViewImpl } from './loaderview';

import { UIComponentCSSStyle } from '../uicomponentcss';


export class LoaderComponent extends UIComponentImpl<UIComponentProps, UIComponentState, UIDataModel>
{
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new LoaderViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new LoaderCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/loader/loadercomponent.tsx